import React from 'react';
import { Line } from 'react-chartjs-2';
import * as XLSX from 'xlsx';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const MonthlyChart = () => {
    const monthlySales = [
        { month: 'January', totalSales: 1600000.00 },
        { month: 'February', totalSales: 920000.00 },
        { month: 'April', totalSales: 240000.00 },
        { month: 'May', totalSales: 480000.00 },
        { month: 'June', totalSales: 120000.00 },
        { month: 'October', totalSales: 5130000.00 },
        { month: 'November', totalSales: 420000.00 }
    ];

    const data = {
        labels: monthlySales.map(item => item.month),
        datasets: [
            {
                label: 'Total Sales',
                data: monthlySales.map(item => item.totalSales),
                borderColor: 'rgba(75, 192, 192, 1)',
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                fill: true,
                tension: 0.4
            }
        ]
    };

    const options = {
        responsive: true,
        plugins: {
            title: {
                display: false,
                text: 'Monthly Sales for 2024'
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        return `${tooltipItem.raw.toLocaleString()}`;
                    }
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    callback: function (value) {
                        return `$${value.toLocaleString()}`;
                    }
                }
            }
        }
    };

    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(monthlySales);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Monthly Sales");
        XLSX.writeFile(workbook, "Monthly_Sales_Report.xlsx");
    };

    return (
        <div className='p-2'>
            <div className="flex justify-between items-center">
                <h2 className='text-[17px] font-medium text-primary'>Monthly Sales Chart (2024)</h2>
                <button
                    onClick={exportToExcel}
                    className="bg-primary text-white px-4 py-1.5 rounded-md text-[14px] transition"
                >
                    Export to Excel
                </button>
            </div>
            <Line data={data} options={options} />
        </div>
    );
};

export default MonthlyChart;
